import { schema } from 'normalizr';

const conversationSchema = new schema.Entity('conversations');

export default conversationSchema;
